import { Navigate } from 'react-router-dom';
import { useAuth } from './components/general/AuthContext';
import logger from './utils/logger';
import { authStorage } from './utils/storage';

const ProtectedRoute = ({ children }) => {
  const { auth, isInitialized } = useAuth();
  
  logger.log('ProtectedRoute', 'Checking auth state', {
    isInitialized,
    isAuthenticated: auth.isAuthenticated,
    user: auth.user?.username || 'no user',
    path: window.location.pathname
  });
  
  // Don't redirect until auth is initialized
  if (!isInitialized) {
    logger.log('ProtectedRoute', 'Auth not initialized, showing loading');
    return <div>Loading...</div>;
  }
  
  if (auth.isAuthenticated) {
    logger.log('ProtectedRoute', 'User authenticated, rendering children');
    return children;
  } else {
    logger.warn('ProtectedRoute', 'User not authenticated, redirecting to login', {
      auth,
      token: authStorage.getToken() ? 'exists' : 'missing'
    });
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;